import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const renderValue = (value, options) => {
  const optionValue = _.find(options, { value })
  return optionValue ? optionValue.text : ''
}

const ValueToTextCell = props => {
  const { rowIndex, definition, data, ...restProps } = props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]

  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}`}
      className={cx('cell')}
      {...restProps}
    >
      <div
        style={{ width: DataTableUtils.getCellInnerWidth(definition.colProps) }}
        className={cx('text-truncate')}
      >
        {renderValue(_.get(row, field) || row[baseField], definition.options)}
      </div>
    </Cell>
  )
}

/**
 * ValueToTextCell looks at the provided options prop and maps the value to its corresponding text for
 * easy to read formatting.
 * e.g. options: [
 *  {
 *    value: 'DAY_1_REO',
 *    text: 'Day 1 REO',
 *  }
 * ]
 */

ValueToTextCell.propTypes = {
  rowIndex: PropTypes.number,
  definition: PropTypes.shape({
    colProps: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
  }).isRequired,
  data: PropTypes.array,
}

export default ValueToTextCell
